import React, { useState } from 'react';
import { Icon } from '../../icon-svg';
import { cx } from '../../cx';

interface FallbackImageProps {
  src?: string;
  alt?: string;
  className?: string;
  iconClassName?: string;
  fallbackIcon?: React.ReactNode;
}

export const FallbackImage: React.FC<FallbackImageProps> = ({
  src,
  alt = '',
  className = '',
  fallbackIcon = <Icon name="IcLink" size="xxsmall" className="text-grey3 flex-shrink-0" />,
}) => {
  const [imageError, setImageError] = useState(!src);

  const handleError = () => {
    setImageError(true);
  };

  return imageError ? (
    <>{fallbackIcon}</>
  ) : (
    <img src={src} alt={alt} className={cx('w-3 h-3', className)} onError={handleError} />
  );
};
